<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <div class="table-responsive style-three">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0">
                DATE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                REFERENCE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                SUPPLIER
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                STATUS
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                GRAND TOTAL
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                PAID
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                DUE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 text-end pe-0"
              >
                PAYMENT STATUS
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">26/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Solid IT Solution
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fs-14 fw-normal">
                  Received
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $120.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $120.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $00.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-success fs-14 fw-normal">Paid</span>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">25/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Victor James
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-alert fs-14 fw-normal">Ordered</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $2100.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ 00.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $2100.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-danger fs-14 fw-normal">Due</span>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">24/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Anda Smith
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fs-14 fw-normal">
                  Received
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1210.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1210.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $00.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-success fs-14 fw-normal">Paid</span>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">23/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Jennifer Lora
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fs-14 fw-normal">
                  Received
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1500.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1500.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $00.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-success fs-14 fw-normal">Paid</span>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">21/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Angela Carter
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-danger fs-14 fw-normal">Pending</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1100.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $1000.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $100.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-alert fs-14 fw-normal">Partial</span>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <span class="text-optional fs-14">19/09/2023</span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                5389607
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Jonathon Ronan
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fs-14 fw-normal"
                  >Received</span
                >
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $15300.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $15300.00
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $00.00
              </td>
              <td
                class="shadow-none lh-1 fs-14 fw-semibold text-paragraph text-center"
              >
                <span class="badge badge-success fs-14 fw-normal">
                  Received
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row pb-45 align-items-center">
    <div class="col-sm-6">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit"
      >
        <span class="fs-13">Showing product per page</span>
        <select class="text-title border-0 fs-14 bg-transparent">
          <option value="0">10</option>
          <option value="1">20</option>
          <option value="2">30</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 text-sm-end text-center">
      <ul class="page-nav list-style">
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/left-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
        <li><a href="#" class="active">1</a></li>
        <li><a href="#">2</a></li>
        <li><a href="#">3</a></li>
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/right-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SalesReport",
};
</script>